import { render } from "./farmerManage.vue?vue&type=template&id=744c04e2&ts=true"
import script from "./farmerManage.vue?vue&type=script&lang=ts"
export * from "./farmerManage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__